export default __webpack_public_path__ + "static/media/Group9261.b9f0f1ca.svg";